import axios from "axios";
import { getToken } from "../hooks/actions/sessionActions";

const ApiGServer = axios.create({
  baseURL: process.env.REACT_APP_API_GLOBAL_SERVER,
});

ApiGServer.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ApiGServer.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.data?.error === "TokenExpiredError") {
      window.location.href = '/logout';
    }
    return Promise.reject(error);
  }
);

export default ApiGServer;
